var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInCustom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16699,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16699,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#9FA4A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6668 17.6665C29.169 17.6665 26.3335 20.502 26.3335 23.9998C26.3335 27.4976 29.169 30.3332 32.6668 30.3332C36.1646 30.3332 39.0002 27.4976 39.0002 23.9998C39.0002 20.502 36.1646 17.6665 32.6668 17.6665ZM28.3335 23.9998C28.3335 21.6066 30.2736 19.6665 32.6668 19.6665C35.0601 19.6665 37.0002 21.6066 37.0002 23.9998C37.0002 26.3931 35.0601 28.3332 32.6668 28.3332C30.2736 28.3332 28.3335 26.3931 28.3335 23.9998Z",
    fill: "#28475C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1409 35.4304C43.5372 35.815 43.5467 36.4481 43.162 36.8444L40.7178 39.3629C40.5203 39.5664 40.2457 39.6765 39.9624 39.6658C39.679 39.6551 39.4136 39.5246 39.232 39.3068L38.1207 37.9734C37.7671 37.5492 37.8243 36.9186 38.2486 36.565C38.6728 36.2114 39.3034 36.2687 39.657 36.6929L40.0567 37.1724L41.7268 35.4515C42.1114 35.0552 42.7445 35.0457 43.1409 35.4304Z",
    fill: "#28475C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3664 32.6837C35.2027 32.4559 33.9581 32.3332 32.6668 32.3332C29.5821 32.3332 26.7401 33.0343 24.6341 34.219C22.5595 35.3859 21.0002 37.1546 21.0002 39.3332L21.0001 39.4691C20.9986 41.0182 20.9967 42.9625 22.7021 44.3512C23.5414 45.0347 24.7155 45.5207 26.3018 45.8418C27.8925 46.1638 29.9658 46.3332 32.6668 46.3332C36.491 46.3332 39.0801 45.9946 40.8263 45.3445C42.3981 44.7594 43.3299 43.902 43.8273 42.8228C45.7238 41.7286 47.0002 39.68 47.0002 37.3332C47.0002 33.8354 44.1646 30.9998 40.6668 30.9998C39.0067 30.9998 37.4958 31.6386 36.3664 32.6837ZM36.3335 37.3332C36.3335 34.9399 38.2736 32.9998 40.6668 32.9998C43.0601 32.9998 45.0002 34.9399 45.0002 37.3332C45.0002 39.7264 43.0601 41.6665 40.6668 41.6665C38.2736 41.6665 36.3335 39.7264 36.3335 37.3332ZM35.0078 34.4865C34.5764 35.3423 34.3335 36.3094 34.3335 37.3332C34.3335 40.5189 36.6856 43.1552 39.7479 43.6003C38.3203 44.0486 36.1041 44.3332 32.6668 44.3332C30.0345 44.3332 28.1078 44.1668 26.6986 43.8815C25.2849 43.5954 24.459 43.2027 23.965 42.8004C23.0539 42.0585 23.0002 41.0769 23.0002 39.3332C23.0002 38.198 23.8287 36.9667 25.6146 35.9621C27.3692 34.9751 29.8605 34.3332 32.6668 34.3332C33.4749 34.3332 34.2588 34.3865 35.0078 34.4865Z",
    fill: "#28475C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInCustom);
export default __webpack_public_path__ + "static/media/inCustom.44d5019c11f3f532928b16c1cb6d42e1.svg";
export { ForwardRef as ReactComponent };